module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_3.07df7f47.png";